import Vue from 'vue';
import Vuex from 'vuex';
import customer from './../../modules/customer/vuex-modules/customer';
import inventory from './../../modules/inventory/vuex';
import setup from './../../modules/setup/vuex';
import cls from './../../modules/setup/cls/vuex';
import receipts from './../../modules/receipt/vuex';
import sales from './../../modules/sales/vuex';
import lots from './../../modules/lots/vuex';
import bidders from './../../modules/bidders/vuex';
import notes from './../../modules/notes/vuex';
import attachments from './../../modules/attachments/vuex';
import liveBids from './../../modules/live-bids/vuex';
import liveLotsPerformance from './../../modules/live-lots-performance/vuex';
import preBids from './../../modules/pre-bids/vuex';
import invoices from './../../modules/invoices/vuex';
import settlements from './../../modules/settlements/vuex';
import sepa from './../../modules/sepa/vuex';
import global from './modules/global';
import marketing from './../../modules/marketing/vuex';
import bids from './../../modules/bids/vuex';
import notificationActivity from './../../modules/notification-activity/vuex';
import temporaryItems from '../../modules/items/temporary/vuex';
import telephoneBids from '../../modules/telephone-bids/vuex';
import reports from '../../modules/reports/vuex';
import profile from './../../modules/auth/Profile/vuex';
import activities from '../../modules/activities/vuex';
import contracts from './../../modules/contracts/vuex';
import reservations from './../../modules/reservations/vuex'
import vendors from './../../modules/vendors/vuex'
import returnNotes from './../../modules/return-notes/vuex'
import conditionReports from './../../modules/condition-reports/vuex';
import conditionReportImages from './../../modules/condition-report-images/vuex'
import conditionReportRequests from './../../modules/condition-report-requests/vuex';
import relations from './../../modules/relations/vuex'
import checks from "@/modules/checks/vuex";
import bacs from "@/modules/bacs-payments/vuex";
import collections from "@/modules/collections/vuex";
import dpv from '@/modules/dpv/vuex'
import featureRequest from "@/modules/feature-request/vuex";
import policeBooks from './../../modules/police-books/vuex'
import vendorCharges from '@/modules/vendor-charges/vuex'
import transferNotes from "@/modules/transfer-notes/vuex";
import docs from "@/modules/docs/vuex";
import invoicePayments from '@/modules/invoice-payments/vuex'
import settlementPayments from '@/modules/settlement-payments/vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    customer,
    setup,
    receipts,
    checks,
    bacs,
    invoices,
    attachments,
    reports,
    inventory,
    sales,
    lots,
    bidders,
    notes,
    liveBids,
    liveLotsPerformance,
    preBids,
    settlements,
    sepa,
    marketing,
    bids,
    notificationActivity,
    temporaryItems,
    telephoneBids,
    profile,
    activities,
    contracts,
    reservations,
    vendors,
    returnNotes,
    conditionReports,
    conditionReportRequests,
    conditionReportImages,
    relations,
    policeBooks,
    collections,
    vendorCharges,
    dpv,
    featureRequest,
    cls,
    transferNotes,
    docs,
    invoicePayments,
    settlementPayments,
  },
  mutations:{
    SOCKET_ONOPEN (state, event)  {
      Vue.prototype.$socket = event.currentTarget
      Vue.prototype.$ws.initGlobalListener();
      state.global.isSocketConnected = true
      // state.socket.isConnected = true
      console.log("SOCKET_ONOPEN");
    },
    SOCKET_ONCLOSE (state)  {
      // state.socket.isConnected = false
      state.global.isSocketConnected = false
      console.log("SOCKET_ONCLOSE");
    },
    SOCKET_ONERROR (state, event)  {
      console.error("SOCKET_ONERROR", state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE ()  {
      console.log("SOCKET_ONMESSAGE");
      // state.socket.message = message
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT() {
      console.log("SOCKET_RECONNECT");
      // console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR() {
      console.log("SOCKET_RECONNECT_ERROR");
      // state.socket.reconnectError = true;
    },
  },
});

export {
  store,
  Vuex,
}
